import { Dropdown } from 'react-bootstrap';
import { useGetCountries } from '../../../shared/api/queries/getCountries.js';
import { useEffect, useState } from 'react';
import { Currencies } from './Currencies.jsx';
import { useGetCurrencies } from '../../../shared/api/queries/getCurrencies.js';

export const Costs = ({ initialValues, onChange, fullWidth = true, onDelete, onAdd }) => {
  const [choosenCountries, setCountries] = useState([]);
  const countries = useGetCountries();
  const currencies = useGetCurrencies();

  const handleAddCountry = async (id) => {
    console.log('click');
    try {
      setCountries((prev) => {
        const result = [...prev];
        if (id === 'null') {
          const currency = currencies.data.items.find((z) => z.symbol === '$');
          result.push({
            countryId: null,
            costs: [
              {
                currencyId: currency.id,
                value: 0,
              },
            ],
          });
        } else {
          const currentCountry = countries.data.items.find((i) => i.id == id);
          result.push({
            countryId: id,
            costs: currentCountry.currencies.map((i) => ({
              currencyId: i.id,
              value: 0,
            })),
          });
        }
        onAdd && onAdd(result[result.length - 1]);
        return result;
      });
    } catch (e) {
      console.error('handle add country error: ', e);
    }
  };
  const handleChange = (countryId, value) => {
    const updatedCountries = choosenCountries.map((i) => {
      if (i.countryId === countryId) {
        return {
          countryId: i.countryId,
          costs: i.costs.map((z) => {
            if (z.currencyId === value.currencyId) {
              return value;
            } else {
              return z;
            }
          }),
        };
      } else {
        return i;
      }
    });
    
    setCountries(updatedCountries);
    
    if (onChange) {
      onChange({
        countryId: countryId,
        value: {
          currencyId: value.currencyId,
          newValue: value.value,
        },
      });
    }
  };

  const handleDelete = (countryId) => {
    setCountries((prev) => {
      if (onDelete) onDelete(countryId);
      return prev.filter((i) => i.countryId !== countryId);
    });
  };

  useEffect(() => {
    console.log(initialValues);
    if (initialValues) {
      console.log(initialValues);
      setCountries(initialValues);
    }
  }, []);

  if (countries.isLoading || currencies.isLoading) return;

  return (
    <>
      <Dropdown onSelect={handleAddCountry}>
        <Dropdown.Toggle
          variant="primary"
          style={{ minHeight: '45px', width: '100%' }}
          id="dropdown-basic-countries"
        >
          Нажмите чтобы выбрать страну
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {countries.data &&
            countries.data.items?.map((i) => (
              <Dropdown.Item eventKey={i.id} key={i.id}>
                {i.title}
              </Dropdown.Item>
            ))}
          <Dropdown.Divider />
          <Dropdown.Item eventKey="null">В других странах</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      {choosenCountries &&
        choosenCountries.map((i) => (
          <Currencies
            onDelete={handleDelete}
            onChange={(value) => handleChange(i.countryId, value)}
            value={i}
            key={i.countryId}
          />
        ))}
    </>
  );
};
